import videojs from 'video.js';
import 'video.js/dist/video-js.css';
import { registerFcVjsShowcaseShareButton } from './fc-vjs-showcase-share-button';

const initialized = new WeakSet<HTMLVideoElement>();

registerFcVjsShowcaseShareButton();

export function initFcVideoJs(root: ParentNode = document): void {
  root.querySelectorAll<HTMLVideoElement>('video.video-js[data-fc-vjs]').forEach((el) => {
    if (initialized.has(el)) {
      return;
    }
    initialized.add(el);

    const inShowcaseMainOrCardEmbed = Boolean(
      el.closest('.fc-video-showcase__main-embed') || el.closest('.fc-video-showcase__card-embed'),
    );

    const showcaseChrome = inShowcaseMainOrCardEmbed
      ? {
          /* Klik w wideo: play/pause (brak play w pasku — jak typowy embed) */
          userActions: { click: true } as const,
          controlBar: {
            children: [
              'progressControl',
              'volumePanel',
              'subsCapsButton',
              'fullscreenToggle',
              'ShowcaseShareButton',
            ],
            /* Poziomy suwak (jak YT po najechaniu); zwijanie do samej ikony — CSS */
            volumePanel: {
              inline: false,
            },
          },
        }
      : {};

    const player = videojs(el, {
      controls: true,
      /* W sekcji showcase slot ma aspect-ratio 16:9 — fluid (padding-top) zostawiał pusty pas; fill rozciąga player na 100% kontenera */
      fluid: !inShowcaseMainOrCardEmbed,
      fill: inShowcaseMainOrCardEmbed,
      responsive: !inShowcaseMainOrCardEmbed,
      playbackRates: [0.75, 1, 1.25, 1.5],
      preload: 'metadata',
      bigPlayButton: true,
      ...showcaseChrome,
    });

    /* Skin zbliżony do „kartowego” odtwarzacza (jak YT) — tylko CSS, bez assetów YT */
    if (inShowcaseMainOrCardEmbed) {
      player.addClass('fc-vjs--showcase-chrome');
    }
  });
}
